import { Box, Button } from "@mui/material";
import theme from "src/theme";

type Props = {
  options: {
    value: string;
    label: string;
    externalLink?: boolean;
    disabled?: boolean;
  }[];
  value: string;
  setValue: (value: string) => void;
};

export default function NavTabs({ options, value, setValue }: Props) {
  const setVal = (value: string) => () => setValue(value);

  return (
    <Box display="flex" alignItems="center" gap={2} flexGrow="1">
      {options.map(({ value: itemValue, label: itemLabel, externalLink, disabled }) => {
        if (itemValue === value) {
          return <Button
            key={itemValue}
            disabled={disabled}
            size="small"
            variant="text"
            color="primary"
            sx={{
              bgcolor: "#e0f2f7",
              border: "none",
              boxShadow: "none",
              letterSpacing: "0.1em",
              px: "10px",
              py: "2px",
              fontSize: 11,
              fontWeight: 600,
              borderRadius: 12,
              "&:hover": {
                bgcolor: "#e0f2f7",
                boxShadow: "none",
              },
            }}
          >
            {itemLabel}
          </Button>;
        }

        if (externalLink) {
          return <Button
            href={itemValue}
            key={itemValue}
            disabled={disabled}
            size="small"
            variant="text"
            color="primary"
            sx={{
              border: "none",
              boxShadow: "none",
              letterSpacing: "0.1em",
              px: "10px",
              py: "2px",
              fontSize: 11,
              fontWeight: 600,
              borderRadius: 12,
              color: theme.palette.secondary.main,
              "&:hover": {
                bgcolor: "#e0f2f7",
                boxShadow: "none",
                color: theme.palette.primary.main,
              },
            }}
          >
            {itemLabel}
          </Button>;
        }

        return <Button
          key={itemValue}
          disabled={disabled}
          onClick={setVal(itemValue)}
          size="small"
          color="secondary"
          sx={{
            px: "10px",
            py: "2px",
            textTransform: "uppercase",
            fontSize: 11,
            fontWeight: 600,
            borderRadius: 12,
            letterSpacing: "0.1em",
            "&:hover": {
              bgcolor: "#e0f2f7",
              boxShadow: "none",
              color: "primary.main"
            },
          }}
        >
          {itemLabel}
        </Button>;
      })}
    </Box>
  );
}
